import type { AccessEvent } from '../facebook-pixel';

/** Ways in off the waitlist. A friend's invite skipped it, so it is not one. */
export const LET_IN_VIA: readonly string[] = ['referral_unlock', 'admin_release', 'time_release'];

/** How long after being let in the browser may still pair the server's `StartTrial`. */
export const LET_IN_FRESH_MS = 14 * 24 * 60 * 60 * 1000;

export interface ArrivalAccess {
  state: string;
  via: string | null;
  joinedAt: string | Date | null;
}

/**
 * The conversion a member's arrival in the app pairs with the server's: `Contact` while they are
 * held, `StartTrial` in the two weeks after they're let in off the waitlist, otherwise none.
 */
export function arrivalConversion(access: ArrivalAccess, now: number = Date.now()): AccessEvent | null {
  if (access.state === 'waitlisted') {
    return 'Contact';
  }
  if (!access.via || !LET_IN_VIA.includes(access.via) || !access.joinedAt) {
    return null;
  }
  return now - new Date(access.joinedAt).getTime() < LET_IN_FRESH_MS ? 'StartTrial' : null;
}

/** Finishing the waiting wizard: `Schedule`, plus `AddToWishlist` for our target audience. */
export function waitingDoneConversions(isTargetArtist: boolean): AccessEvent[] {
  return isTargetArtist ? ['Schedule', 'AddToWishlist'] : ['Schedule'];
}
